export default __webpack_public_path__ + "static/media/success.d1449bd8.png";